import { ColumnProps } from 'primereact/column';

const defaultColumnProps: (
  align?: 'left' | 'right' | 'center',
  sortable?: boolean,
) => Partial<ColumnProps> = (align = 'right', sortable = true) => ({
  sortable,
  className: 'col',
  alignHeader: align,
  align,
});

export default defaultColumnProps;
